<template>
  <div class="md:max-w-screen-sm mx-auto">
    <h2 class="text-center py-5 px-1 md:pb-5 text-xl md:text-3xl">
      Want to charge your own extra fees?
    </h2>
    <div
      class="rounded-lg bg-white px-5 py-5 shadow-sm md:max-w-screen-sm mx-2 md:mx-0 md:py-10 md:px-10"
    >
      <h2 class="pb-5">What is My Payments?</h2>
      <p class="py-2 font-light">
        My Payments is an optional feature that allows you to charge and collect an additional
        application fee payable to you.
      </p>
      <p class="py-2 font-light">
        On any form you create, you can specify an "extra" fee in addition to Rent Application's
        base fee (base fee is calculated by the reports requested).
      </p>
      <p class="py-2 font-light">
        The extra fee is then automatically added to the application form when the applicant
        applies. The applicant pays with a credit card when completing the online application.
      </p>
      <p class="py-2 font-light">
        Extra fees can be viewed, using this page once you have set up your account.
      </p>

      <div class="flex flex-col md:flex-row py-5 md:py-10">
        <div class="flex flex-col md:w-1/2">
          <h5
            :style="{
              'text-decoration': getCurrentUser.landlord.payments_activation_fee_paid
                ? 'line-through'
                : 'none'
            }"
          >
            Activation Fee:
            {{ getCurrentUser.landlord.payments_activation_fee_paid ? "Paid" : "$50.00" }}
          </h5>
          <p class="text-xs italic text-brand-mid-gray py-1">
            *By activating My Payments I agree to the
            <router-link class="underline" :to="{ name: 'home_my_payments_terms' }" target="_blank"
              >My Payments Terms of Use</router-link
            >
          </p>
        </div>
        <div class="flex items-center justify-end md:w-1/2 py-3 md:py-0">
          <router-link
            tag="div"
            class="w-full md:w-1/2"
            :to="{ name: 'dashboard_my_payments_signup_bank_account_info' }"
          >
            <PrimaryButton>Activate</PrimaryButton>
          </router-link>
        </div>
      </div>

      <h2>FAQ</h2>
      <div class="flex flex-col py-3">
        <div
          class="flex flex-col py-2 cursor-pointer border-b border-brand-light-gray"
          v-for="(faq, index) in faqs"
          :key="`faq-${index}`"
          @click="toggleFaq(index)"
        >
          <div class="flex flex-row justify-between">
            <div class="flex flex-1 flex-row items-center">
              <h5 class="mr-5 text-base md:text-lg font-bold text-brand-blue">
                {{ index + 1 }}
              </h5>
              <p class="text-sm md:text-lg">{{ faq.question }}</p>
            </div>
            <div class="flex flex-row items-center">
              <PlusIcon
                class="w-5 h-5 text-brand-green transform transition duration-400 ease-in-out"
                :class="[faq.open ? 'rotate-45' : '']"
              />
            </div>
          </div>

          <div class="py-3 px-1 md:px-8" v-if="faq.open">
            <p class="whitespace-pre-line text-sm">
              {{ faq.answer }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { PlusIcon } from "@heroicons/vue/outline"

import { mapGetters } from "vuex"

export default {
  components: {
    PlusIcon
  },
  computed: {
    ...mapGetters(["getCurrentUser"])
  },
  data() {
    return {
      faqs: [
        {
          question: "How often do withdrawal/transfers occur?",
          answer:
            "Withdrawals of accumulated fees is processed monthly on the 1st via ACH transfer to your checking account.\n\nWithdrawals are subject to the following restrictions:\n1. On closing an account, all funds will be paid to the account of record via ACH regardless of the previous withdrawal time and current balance.\n2. Payout transfers initiated on the 1st of the month may not include fees processed after the 25th of the month and the remaining balance will be shown as available in your account."
        },
        {
          question: "What is the setup fee?",
          answer:
            "Rent Application charges a one-time $50.00 setup fee to configure your account to be able to accept your own application fees."
        },
        {
          question: "Is there a processing fee?",
          answer:
            "For each application processed with your additional fee, a credit card processing fee of $0.30 + [ 3.4% of the total amount ] will be charged and taken from the amount received."
        }
      ]
    }
  },
  methods: {
    toggleFaq(index) {
      this.faqs[index].open = !this.faqs[index].open
    }
  }
}
</script>
